"use client";

import { chakra, Grid, useMultiStyleConfig, VStack } from "@chakra-ui/react";
import React from "react";
import { GetProductPagesByFamilyIdQuery } from "src/__generated__/cms-schema.codegen";
import { ProductOverviewItem } from "./ProductOverviewItem";
import { getLinkProps } from "../Link/utils";

export type ProductPage =
	GetProductPagesByFamilyIdQuery["allProductPages"][number];
export type ProductOverviewProps = {
	productCategories: Record<string, Array<ProductPage>>;
	introAlignment: string;
};

export const ProductOverview: React.FC<ProductOverviewProps> = ({
	productCategories,
	introAlignment,
}) => {
	const styles = useMultiStyleConfig("ProductOverview", { introAlignment });

	return (
		<chakra.div backgroundColor="brand.lighter" padding="2rem">
			<VStack maxWidth="container.xl" gap={12} margin="auto">
				<Grid
					sx={styles.grid}
					templateColumns={{
						base: "repeat(1, 1fr)",
						md: "repeat(2, 1fr)",
						xl: "repeat(3, 1fr)",
					}}
				>
					{Object.entries(productCategories).map(
						([categorySlug, products]) => {
							if (categorySlug === "undefined") {
								return products.map((product) => {
									const externalLink = product.externalLink
										? getLinkProps(product.externalLink)
										: null;

									return (
										<ProductOverviewItem
											key={product.id}
											id={product.id}
											name={product.name}
											href={`/${product.productFamily.slug}/${product.slug}`}
											image={product.img}
											description={
												product.teaserText ?? ""
											}
											price={
												product.currentVersion?.price ??
												null
											}
											priceDescription={
												product.currentVersion
													?.priceDescription ?? null
											}
											isOnlineApplication={Boolean(
												product.isOnlineApplication,
											)}
											externalLink={externalLink}
										/>
									);
								});
							}

							const category = products[0]?.productCategory;

							if (!category) return null;

							return (
								<ProductOverviewItem
									key={category.id}
									id={category.id}
									name={category.name}
									href={`${category.productFamily.slug}/${category.slug}`}
									image={category.img}
									description={category.teaserText ?? ""}
									price={category.price}
									priceDescription={category.priceDescription}
									isOnlineApplication={category._allReferencingProductPages.every(
										({ isOnlineApplication }) =>
											Boolean(isOnlineApplication),
									)}
								/>
							);
						},
					)}
				</Grid>
			</VStack>
		</chakra.div>
	);
};

// 🔬 TBD
